import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/app/environments/environment';
import { Observable } from 'rxjs';
import {IAdminUser, ICompany, IJobOffer, IUser} from '../../../../assets/types/dtoTypes';

@Injectable( {
  providedIn: 'root',
} )
export class AdminDashboardPageService {
  private http = inject(HttpClient);


  private companiesURL = `${environment.apiUrl}/companies`;

  private usersUrl = `${environment.apiUrl}/users`;

  private adminUsersUrl = `${environment.apiUrl}/admin/users`;

  private companyUrl = `${environment.apiUrl}/job-offers/company`;

  constructor() {
  }

  createCompany( company: Partial<ICompany> ): Observable<ICompany> {
    return this.http.post<ICompany>( this.companiesURL, company );
  }


  getAllUsers(): Observable<IUser[]> {
    return this.http.get<IUser[]>( this.usersUrl );
  }

  /** Admin read model: includes email + applicationsCount in a single call (no N+1). */
  getAdminUsers(): Observable<IAdminUser[]> {
    return this.http.get<IAdminUser[]>( this.adminUsersUrl );
  }

  getAllComapanies(): Observable<ICompany[]> {
    return this.http.get<ICompany[]>( this.companiesURL );
  }

  getAllJobOffersByCompany(companyId: string): Observable<IJobOffer[]> {
    return this.http.get<IJobOffer[]>(`${this.companyUrl}/${companyId}`);
  }

}
